// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BrowserMatchTypeSchema = z.enum(['URL','HEADER','BODY','STATUS_CODE','METHOD','ADD_HEADER','REMOVE_HEADER','PARAM_NAME','PARAM_VALUE','FIRST_LINE'] as const);

export type BrowserMatchTypeType = `${z.infer<typeof BrowserMatchTypeSchema>}`

export default BrowserMatchTypeSchema;
